var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticStyle:{"position":"fixed","top":"55px","left":"0","right":"0","bottom":"0","display":"flex","justify-content":"center","align-items":"center","z-index":"111","background":"rgba(0, 0, 0, 0.8)"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }